export { default as BCollectionHighlight } from '@/components/main/sections/b.CollectionHighlight/b.CollectionHighlight.js';
